import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageProvider";
import Analytics from "@/components/site/Analytics";

function SkipLink() {
    return (
        <a
            href="#main"
            className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-sm focus:bg-primary focus:text-primary-foreground focus:shadow-lg"
        >
            Skip to main content
        </a>
    );
}

function App() {
    return (
        <div className="App grain-overlay">
            <BrowserRouter>
                <LanguageProvider>
                    <SkipLink />
                    <Analytics />
                    <Routes>
                        {/* English (default) */}
                        <Route path="/" element={<Landing />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        {/* Hindi */}
                        <Route path="/hi" element={<Landing />} />
                        <Route path="/hi/privacy" element={<Privacy />} />
                        <Route path="/hi/terms" element={<Terms />} />
                    </Routes>
                </LanguageProvider>
            </BrowserRouter>
            <Toaster position="bottom-center" richColors closeButton />
        </div>
    );
}

export default App;
